import { render, staticRenderFns } from "./user_tab2.vue?vue&type=template&id=54d3719c&scoped=true"
import script from "./user_tab2.vue?vue&type=script&lang=js"
export * from "./user_tab2.vue?vue&type=script&lang=js"
import style0 from "./user_tab2.vue?vue&type=style&index=0&id=54d3719c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d3719c",
  null
  
)

export default component.exports